import {
  Fade,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Box from "@mui/material/Box";
import React, { useMemo, useRef } from "react";
import FlipCard from "../components/FlipCard";
import LayerHeading from "../components/LayerHeading";
import Section from "../components/Section";
import { useIsVisible } from "../hooks/useIsVisible";
import f1 from "../images/NewUI/f1.png";
import f2 from "../images/NewUI/f2.png";
import f3 from "../images/NewUI/f3.png";
import f4 from "../images/NewUI/f4.png";
import f5 from "../images/NewUI/f5.png";
import f6 from "../images/NewUI/f6.png";
import featureBg1 from "../images/NewUI/feature_bg1.png";
import featureBg2 from "../images/NewUI/feature_bg2.png";
import featureBg3 from "../images/NewUI/feature_bg3.png";
import leftEffect from "../images/NewUI/left_effect.png";
import sixProtocol from "../images/NewUI/six_protocol_full.png";

const FeaturesSectionStyle = styled("div")`
  background: url(${featureBg3});
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;

  .bg1 {
    position: relative;
    z-index: 1;

    > img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: initial;
    }
  }

  .bg2 {
    background: url(${featureBg2});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

const FeaturesSection = () => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const ref = useRef();
  const isVisible = useIsVisible(ref);

  const features = useMemo(() => {
    return [
      {
        title: "Marking Usage Value",
        detail: `The business can embed the use case and redeemable inventory for the users to obtain their rights.`,
        img: f1,
      },
      {
        title: "Point System",
        detail: `Dynamic Metadata allows the NFT to collect the point and work as a membership or CRM tool for the users and brands.`,
        img: f2,
      },
      {
        title: "Proof of Attendance",
        detail: `Users can use the NFT as a Proof of Attendance concept as a fraud-free ticket to attend the events or complete the quest and journey.`,
        img: f3,
      },
      {
        title: "Mergeable Attribute",
        detail: `Once the users have completed their task or quest, the attribute of NFT can be merged with new attributes.`,
        img: f4,
      },
      {
        title: "Transformable NFT",
        detail: `Dynamic Metadata allows the collection owner to change the artwork on NFT. The business can create a business case related to artwork transformation and its attributes to create uniqueness as a symbol of use.`,
        img: f5,
      },
      {
        title: "Delegating Gas Fee",
        detail: `Via fee delegation address, users can process any NFT transaction without having to prepare for a gas fee which will be provided by either the business or the collection owner.`,
        img: f6,
      },
    ];
  }, []);

  return (
    <FeaturesSectionStyle>
      <Section pb="0">
        <LayerHeading mb={4}>USE CASES</LayerHeading>
        <Box
          display="grid"
          gridTemplateColumns={{ xs: "1fr ", sm: "1fr 1fr", md: "1fr 1fr 1fr" }}
          gap={3}
          justifyItems="center"
          className="bg1"
        >
          <img ref={ref} src={featureBg1} alt="" height="100%" />
          {features.map((f) => (
            <FlipCard
              key={f.title}
              title={f.title}
              detail={f.detail}
              img={f.img}
            />
          ))}
        </Box>
      </Section>

      <Section pb="0" className="bg2 p-relative">
        <Fade in={isVisible} {...(isVisible ? { timeout: 3000 } : {})}>
          <img
            ref={ref}
            src={leftEffect}
            alt=""
            width="40%"
            style={{ position: "absolute", top: "0", left: "0" }}
          />
        </Fade>

        <div className="p-relative" style={{ zIndex: 1 }}>
          <Typography variant="h5" textTransform="uppercase" align="center">
            SIX Protocol
          </Typography>
          <Typography
            variant="h2"
            textTransform="uppercase"
            align="center"
            lineHeight={1}
            my={1}
          >
            Powerful Blockchain
          </Typography>
          <Typography
            variant="h5"
            textTransform="uppercase"
            align="center"
            fontWeight="normal"
            mb={2}
          >
            Behind NFT Gen2
          </Typography>

          <Typography align="center" whiteSpace="pre-line" mb={5}>
            {`SIX Protocol is a blockchain infrastructure that has been designed for real world business and enterprise.
    On the SIX Protocol, there are components that have been prepared for the business that wants to enable the power of Web3.`}
          </Typography>

          <img
            src={sixProtocol}
            alt=""
            width={sm ? "80%" : "100%"}
            className="d-block mx-auto"
          />
        </div>
      </Section>
    </FeaturesSectionStyle>
  );
};

export default FeaturesSection;
